module.exports = __webpack_public_path__ + "static/media/blueVert.1a169d52.png";